import { useCache as zampleUseCache } from '@zample-com/fetch/swr';

import httpClient from '../libs/http-client';

function useCache() {
	return zampleUseCache({ httpClient });
}

export default useCache;
